import { useState } from 'react';

interface Props {
  payloadJson: string;
}

export default function NotifyPayloadView({ payloadJson }: Props) {
  const [expanded, setExpanded] = useState(false);

  let pretty = payloadJson;
  try {
    pretty = JSON.stringify(JSON.parse(payloadJson), null, 2);
  } catch {
    // leave raw
  }

  return (
    <div>
      <button
        type="button"
        className="text-xs text-pebbl-600 hover:text-pebbl-800"
        onClick={() => setExpanded((v) => !v)}
      >
        {expanded ? '− hide payload' : '+ show payload'}
      </button>
      {expanded && (
        <pre className="mt-1 text-xs bg-gray-50 border border-gray-200 rounded p-2 overflow-x-auto">
          {pretty}
        </pre>
      )}
    </div>
  );
}
